module.exports = __webpack_public_path__ + "static/media/question-bank.baca8ca1.png";